




































import Vue from 'vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState(['loggedUser']),
    },

    methods: {
        ...mapActions(['setUser']),
        async logOut() {
            this.setUser(null);
            this.$router.push('/login');
        },
    },
});
